import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Delete alerts
 *
 * @private
 */
export const deleteAlerts = createAsyncThunk<
  // Return type of the alertIds creator
  void,
  // First argument to the alertIds creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/alert/delete', async (ids, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/alert/delete', {
      category: 'rpc',
      type: 'rpc/alert/delete',
      ids,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deleteAlert}`,
      { tags: ['rpc', 'alert'], info: ids },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Delete alert failed`,
      error,
    })
  }
})
